import type { FunctionComponent } from "react";
import CampaignPostsAdminPartial from "../../../partials/admin/home/campaign-posts/campaign-posts.admin.partials";
import { PostStatus } from "../../../types/models/post.models.types";
import { useParams } from "react-router-dom";

export const CampaignDraftSubmissionsAdminScreen: FunctionComponent = () => {
	const { campaignId } = useParams();

	if (!campaignId) {
		throw new Error("campaign id not found");
	}

	return (
		<CampaignPostsAdminPartial
			tabs={[
				{
					status: PostStatus.draft,
					title: "Pending approval",
					flagged: false,
				},
				{
					status: PostStatus.draftApproved,
					title: "Approved",
					flagged: false,
				},
				{
					status: PostStatus.draftRejected,
					title: "Rejected",
					flagged: false,
				},
			]}
			initialStatus={PostStatus.draft}
			campaignId={campaignId}
		/>
	);
};
